// extracted by mini-css-extract-plugin
export default {"header":"ProdGroups_header__bSWlU","title":"ProdGroups_title__3Vr8z"};